var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02D1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.7646,
    cy: 12.9412,
    r: 6,
    fill: "url(#paint0_linear_10214_598)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_10214_598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9962 22.555H10.186C7.60386 22.555 6.11768 20.9027 6.11768 18.8603C6.11768 17.0918 7.23854 15.6969 8.89909 15.2237C9.18969 11.9109 11.913 9.41176 15.1344 9.41176C17.6004 9.41176 19.6262 10.7485 20.7305 12.9404C23.7444 12.9404 25.9612 14.9995 25.9612 17.7311C25.9612 20.4378 23.7942 22.555 20.9962 22.555Z",
    fill: "#9DCBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3956 13.1091L20.4995 13.3154H20.7305C23.5674 13.3154 25.5862 15.2355 25.5862 17.7311C25.5862 20.2212 23.5967 22.18 20.9962 22.18H10.186C8.97676 22.18 8.05784 21.7947 7.44361 21.2034C6.82895 20.6117 6.49268 19.7885 6.49268 18.8603C6.49268 17.2674 7.49448 16.0139 9.00187 15.5843L9.2501 15.5136L9.27266 15.2564C9.54664 12.1331 12.1116 9.78676 15.1344 9.78676C17.4494 9.78676 19.3507 11.0352 20.3956 13.1091Z",
    stroke: "url(#paint1_linear_10214_598)",
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_10214_598",
    x: -13.8823,
    y: -10.5882,
    width: 59.8435,
    height: 53.1432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_598",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10214_598",
    x1: 25.7646,
    y1: 6.94118,
    x2: 13.7646,
    y2: 18.9412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBEB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BB5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10214_598",
    x1: 6.11768,
    y1: 9.41176,
    x2: 26,
    y2: 22.5882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.248703,
    stopColor: "#DCEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742629,
    stopColor: "#A1CDFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02D1);
export default __webpack_public_path__ + "static/media/02d-1.09b2805aa170054e403bb7c0232e563b.svg";
export { ForwardRef as ReactComponent };